import React from 'react'
import { FUNCTION } from '../services/Macro'
import { Page } from '../services/Page'
export default class Sidebar extends React.Component {

    state = {

    }

    toggleSidebar = () => {
        console.log(`开关侧边栏`)

        // 在 html 上增减一个 sidebar-left-collapsed 样式
        const html = document.getElementsByTagName("html")[0]
        console.log(html);
        if (html.classList.contains('sidebar-left-collapsed')) {
            html.classList.remove('sidebar-left-collapsed')
        }
        else {
            html.classList.add('sidebar-left-collapsed')
        }
    }

    render() {
        let t = this.props.trans
        return (
            <aside id="sidebar-left" className="sidebar-left">

                <div className="sidebar-header">
                    <div className="sidebar-title">
                        Navigation
                    </div>
                    <div className="sidebar-toggle hidden-xs"
                        data-toggle-class="sidebar-left-collapsed"
                        data-target="html"
                        data-fire-event="sidebar-left-toggle"
                        onClick={this.toggleSidebar}>
                        <i className="fa fa-bars" aria-label="Toggle sidebar"></i>
                    </div>
                </div>

                <div className="nano">
                    <div className="nano-content">
                        <nav id="menu" className="nav-main" role="navigation">
                            <ul className="nav nav-main">
                                {this.renderAccountMgmt()}
                                {this.renderUpgradeMgmt()}
                                {this.renderSysMgmt()}
                                {this.renderStats()}
                                {this.renderLogMgmt()}
                                {this.renderDynamic()}
                                {this.renderCalendar()}
                                {this.renderPushMgmt()}
                                {/* {this.renderSdkPage()} */}
                            </ul>
                        </nav>
                        <hr className="separator" />
                    </div>
                </div>
            </aside>
        )
    }

    /** 渲染账户管理 */
    renderAccountMgmt() {
        if (FUNCTION.ACCOUNT_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.accountMgmt ? "nav-active" : ""}>
                    <a href={Page.accountMgmt}>
                        <i className="fa fa-group" aria-hidden="true"></i>
                        <span>{t('accountMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染升级管理 */
    renderUpgradeMgmt() {
        if (FUNCTION.UPGRADE_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.firmware ? "nav-active" : ""}>
                    <a href={Page.firmware}>
                        <i className="fa fa-arrow-up" aria-hidden="true"></i>
                        <span>{t('upgradeMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染系统管理 */
    renderSysMgmt() {
        if (FUNCTION.SYS_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.system ? "nav-active" : ""}>
                    <a href={Page.system}>
                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>{t('systemMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染数据管理 */
    renderStats() {
        if (FUNCTION.STATS_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.stats ? "nav-active" : ""}>
                    <a href={Page.stats}>
                        <i className="fa fa-arrow-down" aria-hidden="true"></i>
                        <span>{t('statsMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染日志管理 */
    renderLogMgmt() {
        if (FUNCTION.LOG_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.logs ? "nav-active" : ""}>
                    <a href={Page.logs}>
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        <span>{t('logsMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染动态管理 */
    renderDynamic() {
        if (FUNCTION.DYNAMIC_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.dynamic ? "nav-active" : ""}>
                    <a href={Page.dynamic}>
                        <i className="fa fa-dot-circle-o" aria-hidden="true"></i>
                        <span>{t('dynamicMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染日历管理 */
    renderCalendar() {
        if (FUNCTION.CALENDAR_VIEW) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.calendar ? "nav-active" : ""}>
                    <a href={Page.calendar}>
                        <i className="fa fa-vimeo-square" aria-hidden="true"></i>
                        <span>{t('calendar')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染推送管理 */
    renderPushMgmt() {
        if (FUNCTION.PUSH_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.pushMgmt ? "nav-active" : ""}>
                    <a href={Page.pushMgmt}>
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                        <span>{t('pushMgmt')}</span>
                    </a>
                </li>
            )
        }
    }

    /** 渲染SDK说明页 */
    renderSdkPage() {
        if (FUNCTION.SDK_MGMT) {
            let t = this.props.trans
            return (
                <li className={this.props.selectMenu === Page.sdkMgmt ? "nav-active" : ""}>
                    <a href={Page.sdkIntro}>
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                        <span>{t('sdkMgmt')}</span>
                    </a>
                </li>
            )
        }
    }
}